import merge from 'lodash/merge';

import {
    MANAGE_ORDER_LOCK,
    TOGGLE_SERVICE_TIMEOUT,
    RECEIVE_UTILITY,
    RECEIVE_USER_IDLE,
    NULL_UTIL_STATE,
} from './utility-actions';

const NULL_STOREDATA_STATE = {
    labels: {
        add2Cart: 'Add to cart',
        add2Quote: 'Add to quote',
        addMsg: 'Just added to cart',
        backOrder: 'Back-order',
        cartCheckout: 'Checkout',
        cartSubtotal: 'Sub-total',
        cartTaxFee: 'before tax &amp; fees',
        cartTxt: 'View all items',
        cartView: 'view cart &amp; check out',
        comingSoon: 'Coming soon',
        customizeBtn: 'Customize &amp; buy',
        customizeOnlyBtn: 'Customize',
        emptyCart: 'There are no items in your cart',
        invLeft: 'Left!',
        invOutOfStock: 'Out of stock',
        mcchq: 'QTY',
        poboOOSMsg: 'Pre-orders sold out',
        poboShipMsg: 'Estimated shipping date:',
        preOrder: 'Pre-order now',
        viewSupplies: 'View supplies',
    },
};

export const StoreDataReducer = (state = NULL_STOREDATA_STATE, action) => {
    Object.freeze(state);
    switch (action.type) {
        case RECEIVE_UTILITY:
            return merge({}, state, action.utilityInfo.storeData);
        default:
            return state;
    }
};

const UtilityReducer = (state = NULL_UTIL_STATE, action) => {
    Object.freeze(state);
    const newState = merge({}, state);
    switch (action.type) {
        case RECEIVE_UTILITY:
            newState.profileData = action.utilityInfo.profileData;
            if (action.updatedFromService === true) {
                newState.updatedFromService = true;
            }
            return newState;
        case MANAGE_ORDER_LOCK:
            newState.callCenter.orderLock = action.orderLock;
            return newState;
        case TOGGLE_SERVICE_TIMEOUT:
            newState.serviceTimeout = action.toggle;
            return newState;
        case RECEIVE_USER_IDLE:
            newState.userIdle = action.userIdle;
            return newState;
        default:
            return state;
    }
};

export default UtilityReducer;
